const title = "How to reconstructing a fatty acyl profile";
const description = "Learn how to upload your data set, set parameters, and reconstruct the fatty acyl profiles.";


const Tutorial = ({title}) => (
  <>
    <h3>{title}</h3>
    <p>
      Start reconstructing the fatty acid information quickly:
      <ol>
        <li>Click the <strong>Browse...</strong> button to select a lipid profile in one of the supported data formats</li>
        <li>Upload the selected file by clicking the <strong>Upload</strong> button
          <ul>
            <li>The lipid profile is parsed to extract the available assays and lipid classes</li>
            <li>This may take some time if the uploaded file contains many assays and lipid species</li>
            <li>The button should turn green now</li>
          </ul>
        </li>
        <li><strong>Select the assays</strong> for which the fatty acid information should be reconstructed</li>
        <li><strong>Select the lipid classes</strong> for which the fatty acid information should be reconstructed</li>
        <li><strong>Select a fatty acid set</strong> that fits to your selected assays.</li>
        <li>The default optimization parameters are fine for most applications and do not have to be adjusted.</li>
        <li>Start the optimization by clicking the <strong>Submit job</strong> button
          <ul>
            <li>This may take a short while if you selected many assays and lipid species for optimization</li>
          </ul>
        </li>
        <li>Analyze and compare the modeled fatty acid and lipid profiles</li>
        <li>Save the results containing 
          <ul>
            <li>summary report</li>
            <li>graphs</li>
            <li>detailed output files</li>
          </ul>
          of the modeled fatty acid and lipid profiles by pressing the <strong>Download results</strong> button.
        </li>
      </ol>
    </p>
  </>
)

export const ReconstructingTutorial = ({prefix}) => {
  const title_ = prefix ? prefix + title : title;
  return {
    title: title_,
    section: "reconstructing",
    description: description,
    tutorial: () => Tutorial({title: title_})
  }
}
